import { Controller } from "@hotwired/stimulus"

// A "floating label" text field: the label sits inside the field until
// there's a value (or a real placeholder) to show, at which point the
// wrapper gets a `filled` class that the CSS uses to float the label up.
// Attaches directly to each .floating-label wrapper; the field itself
// just needs `data-action="input->floating-label#sync ..."` pointing up
// at it, no target wiring required.
export default class extends Controller {
  connect() {
    const field = this.element.querySelector(".form-control")
    if (field) this.sync({ target: field })
  }

  sync(event) {
    const field = event.target
    const value = field.value?.trim()
    const placeholder = field.getAttribute("placeholder")?.trim()
    const hasValue = !!value
    const isMeaningfulPlaceholder = placeholder && placeholder !== " "

    this.element.classList.toggle("filled", hasValue || isMeaningfulPlaceholder)
  }
}
